var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 253",
    d: "M16 0a16 16 0 1016 16A16 16 0 0016 0zm6.362 12.739c.007.14.01.281.01.423A9.337 9.337 0 018 21.028a6.979 6.979 0 00.783.045 6.577 6.577 0 004.076-1.406 3.285 3.285 0 01-3.065-2.279 3.38 3.38 0 00.617.059 3.27 3.27 0 00.864-.116 3.287 3.287 0 01-2.633-3.218v-.041a3.286 3.286 0 001.488.41 3.288 3.288 0 01-1.016-4.383 9.318 9.318 0 006.766 3.43 3.285 3.285 0 015.593-2.995 6.54 6.54 0 002.085-.8 3.292 3.292 0 01-1.443 1.816A6.545 6.545 0 0024 11.034a6.653 6.653 0 01-1.638 1.705z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4e99a0014e3b8daa8e35c5053551334a.svg";
export { ForwardRef as ReactComponent };